export default __webpack_public_path__ + "static/img-ef-2-880a7debc22e2af9057c7736d5bd3cae.png";